/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './FddServe.module.scss';

type Translate = (key: string) => string;

const getTeams = (t: Translate) => [
  {
    num: '01',
    title: t('Credit & risk'),
    desc: t('Set a limit on filed numbers, not a scored guess.'),
    checks: [t('Filed balance sheet'), t('Profit and loss history'), t('Payment and filing behaviour')],
  },
  {
    num: '02',
    title: t('M&A and corporate development'),
    desc: t('Screen and diligence targets before anyone signs an NDA.'),
    checks: [t('Multi-year financials'), t('Group and ownership structure'), t('Filing gaps and late accounts')],
  },
  {
    num: '03',
    title: t('Procurement & supply chain'),
    desc: t('Know whether a supplier can survive the contract.'),
    checks: [t('Net assets and solvency'), t('Employee and turnover trend'), t('Deterioration alerts')],
  },
  {
    num: '04',
    title: t('Data licensing & enrichment'),
    desc: t('Bring filed financials into your own product or model.'),
    checks: [t('Bulk financial export'), t('Daily change files'), t('Redistribution rights')],
  },
];

export const FddServe = () => {
  const { t } = useInt();
  const teams = getTeams(t);

  return (
    <Section className={styles.root}>
      <TitleBlock title={t('Built for the teams that price the risk.')} align="left" />
      <div className={styles.grid}>
        {teams.map((team, i) => (
          <div key={team.num} className={`${styles.col} ${i < teams.length - 1 ? styles.colBorder : ''}`}>
            <span className={styles.num}>{team.num}</span>
            <h3 className={styles.teamTitle}>{team.title}</h3>
            <p className={styles.teamDesc}>{team.desc}</p>
            <ul className={styles.checks}>
              {team.checks.map((check) => (
                <li key={check} className={styles.checkItem}>
                  <span className={styles.checkIcon}>✓</span>
                  <span>{check}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Section>
  );
};
